export enum ShareObjectStatus {
    Approved = 'Approved',
    Rejected = 'Rejected',
    PendingApproval = 'PendingApproval',
    Draft = 'Draft',
    Draft_Remove = 'Draft_Remove',
    Shared = 'Shared',
    Removing = 'Removing',
}

export interface AddShareItemsInput {
    itemUri: string;
    itemType: string;
}

export interface ShareItem {
    name: string;
    itemUri: string;
    shareItemUri: string;
    itemType: string;
    itemName: string;
    status: ShareObjectStatus;
    approver: string;
    owner: string;
    checked?: boolean;
    disabled?: boolean;
}

export interface ShareRequestItem {
    datasetUri: string;
    name: string;
    shareUri: string;
    locationUri?: string;
    tableUri?: string;
}

export enum DataType {
    dataset = 'dataset',
    table = 'table',
    location = 'location',
}

export interface Role {
    label: string;
    value: string;
}

interface ShareObjectItem {
    datasetUri: string;
    itemType: string;
    itemUri: string;
}

interface ShareObjectInput {
    principalId: string;
    principalType: string;
    currentRole: string;
    currentStages: string[];
    currentAccounts: string[];
    skipShareEmail?: boolean;
}

export interface ShareObjectRequest extends ShareObjectItem {
    input: ShareObjectInput;
}

export interface ShareObjectInfo {
    [DataType.dataset]: ShareObjectItem;
    [DataType.location]: ShareObjectItem;
    [DataType.table]: ShareObjectItem;
}

export interface ShareObject {
    created: string;
    samlGroupName: string;
    principal: {
        region: string;
        AwsAccountId: string;
        principalId: string;
    };
    dataset: {
        datasetUri: string;
    };
}

export interface AwsEnvironment {
    account: string;
    checked: boolean;
    stage: string;
    label: string;
}

export interface EnvironmentsCheckboxes {
    devAccount: AwsEnvironment;
    prodAccount: AwsEnvironment;
    testAccount: AwsEnvironment;
    valAccount: AwsEnvironment;
}

export interface SelectedEnvironment {
    label: string;
    name: string;
    devAccount: string;
    prodAccount: string;
    testAccount: string;
    valAccount: string;
}
